import BookingFormAttemptFailedListener from "../../services/listener/internal/bookingFormAttemptFailedListener";
import BookingService from "../../services/book/bookingService";
import DateFetchService from "../../services/book/paramFetcher/dateFetchService";
import BookingConfigurator from "../../services/book/bookingConfigurator";
import SendBudget from "../../services/book/sendBudget";
import BookingPaymentConfigurator from "../../services/book/bookingPaymentConfigurator";
import BookingInvoiceManager from "../../services/book/bookingInvoiceManager";
import ChollosFilterer from "../../services/filterer/chollos/chollosFilterer";
import Step1Manager from "../../services/book/step1Manager";
import Step2Manager from "../../services/book/step2Manager";
import Step3Manager from "../../services/book/step3Manager";
import FreeCancelPoliciesListener from "../../services/listener/freeCancelPoliciesListener";
import CallNowNotificationManager from "../../services/book/CallNowNotificationManager";
import BookingSummaryManagerVPT from "@web/vpt-assets/assets/js/utilities/bookingSummary/bookingSummaryManager";
import ItineraryManager from "../../services/itinerary/itineraryManager";
import GroupThematicReviewManager from "../../services/group/groupThematicReviewManager";
import UserExclusiveService from "../../services/user/userExclusiveService";
import BookGoBackManager from "../../services/book/bookGoBackManager";

$(function ()
{
    myApp.bookingFormAttemptFailedListener = new BookingFormAttemptFailedListener();
    myApp.bookingService = new BookingService();
    myApp.dateFetchService = new DateFetchService();
    myApp.step1Manager = new Step1Manager();
    myApp.step2Manager = new Step2Manager();
    myApp.step3Manager = new Step3Manager();
    myApp.bookingConfigurator = new BookingConfigurator();
    myApp.sendBudget = new SendBudget();
    myApp.bookingPaymentConfigurator = new BookingPaymentConfigurator();
    myApp.form.book.bookingInvoiceManager = new BookingInvoiceManager();
    myApp.filterer.chollos = new ChollosFilterer();
    myApp.freeCancelPoliciesListener = new FreeCancelPoliciesListener();
    myApp.callNowNotification = new CallNowNotificationManager();
    new BookingSummaryManagerVPT();
    new ItineraryManager();
    new GroupThematicReviewManager();
    new UserExclusiveService();
    if (typeof modalIdGoBack !== "undefined") {
        new BookGoBackManager(modalIdGoBack);
    }
});
